import {Component, Input} from '@angular/core';
import {TranslateModule} from "@ngx-translate/core";
import {MatIconModule} from "@angular/material/icon";
import {MatTooltip} from "@angular/material/tooltip";
import {LipoFormControlIconSetting} from "../../models/lipo-form-control.model";

@Component({
  selector: 'du-label-icon-tooltip',
  imports: [
    MatIconModule,
    MatTooltip,
    TranslateModule,
  ],
  templateUrl: './label-icon-tooltip.component.html',
  styleUrl: './label-icon-tooltip.component.scss'
})
export class LabelIconTooltipComponent {
  @Input() label!: string;
  @Input() iconSetting?: LipoFormControlIconSetting;
}
